// extracted by mini-css-extract-plugin
export default {"contributorItem":"community_contributorItem__4aq5H","linkTo":"community_linkTo__ZBbyx","linkItem":"community_linkItem__hoJ9C","contributorName":"community_contributorName__cVvcz"};